import MonacoEditor from '@monaco-editor/react';

interface EditorProps {
  value: string;
  onChange: (value: string) => void;
  language: string;
  darkMode: boolean;
  readOnly?: boolean;
}

function Editor({ value, onChange, language, darkMode, readOnly = false }: EditorProps) {
  return (
    <div className="h-full">
      <MonacoEditor
        height="100%"
        language={language}
        value={value}
        onChange={(val) => onChange(val || '')}
        theme={darkMode ? 'vs-dark' : 'light'}
        options={{
          minimap: { enabled: false },
          fontSize: 14,
          lineNumbers: 'on',
          scrollBeyondLastLine: false,
          automaticLayout: true,
          readOnly,
          wordWrap: 'on',
          wrappingIndent: 'indent',
          tabSize: 2,
        }}
      />
    </div>
  );
}

export default Editor;
